import { setStorage } from '@getjust/commons';
import { useCallback } from 'react';

import { useShop } from '$src/hooks/queries';
import { useCartIdAtom } from '$src/hooks/state';

export const useCartIdUpdater = () => {
  const { cartId, onCartIdChange } = useCartIdAtom();
  const { data: shop } = useShop();
  const updateCartId = useCallback(
    (id: string) => {
      if (id && cartId !== id && shop?.id) {
        onCartIdChange(id);
        setStorage<string>('localStorage', `just_session_id_${shop.id}`, id);
      }
    },
    [cartId, onCartIdChange, shop?.id],
  );
  return updateCartId;
};
